import nativeBridge from "./nativeBridge";

/**
 * Uniquely identify buttons in the app for analytics.
 * A description for each button identifier, clarifies its purpose.
 * Use kebab-case for naming.
 */
type ButtonIdentifier =
  | 'create-account-via-website' // Redirects to the website to create an account.
  // | 'some-other-button' // Extend this as needed.
;

/**
 * A centralized service for sending analytics events from the app to analytics services via the native container.
 * Adding new analytics events here helps keep track of what events are being sent,
 * and ensures consistency in event naming and parameters.
 *
 * Eventually, this may be encapsulated by a hook, if future dependencies warrant it.
 *
 * NAMING CONVENTIONS:
 *   Use singular, present tense, and the subject proceeds the action.
 * Method names
 *   - Follow the pattern on[Subject]_[Action].
 *   - e.g., onButton_press.
 * Event names
 *   - Use snake case.
 *   - e.g., button_press.
 */
class InAppAnalyticsService {
  /**
   * @param buttonIdentifier Uniquely identifies the button. Potentially used in conversion funnels.
   */
  onButton_press(buttonIdentifier: ButtonIdentifier) {
    nativeBridge.sendAnalyticsEvent('button_press', {
      buttonIdentifier,
      // ...deviceInfo, // Consider adding something like this later, for additional context.
    });
  }

  async getAppInstanceID(): Promise<string | null> {
    if (!nativeBridge.isRunningInNativeContainer) {
      return null;
    }
    return await nativeBridge.getAppInstanceId();
  }
}

export const inAppAnalyticsService = new InAppAnalyticsService();
